export default __webpack_public_path__ + "static/blob-42-4fd2544c98b88966334831a4630e86f2.svg";